console.log("Loaded");

// Marquee
function marquee(selector, speed) {
  const parentSelector = document.querySelector(selector);
  const clone = parentSelector.innerHTML;
  const firstElement = parentSelector.children[0];
  let i = 0;

  parentSelector.insertAdjacentHTML("beforeend", clone);
  parentSelector.insertAdjacentHTML("beforeend", clone);
  parentSelector.insertAdjacentHTML("beforeend", clone);
  parentSelector.insertAdjacentHTML("beforeend", clone);
  parentSelector.insertAdjacentHTML("beforeend", clone);
  parentSelector.insertAdjacentHTML("beforeend", clone);
  parentSelector.insertAdjacentHTML("beforeend", clone);
  parentSelector.insertAdjacentHTML("beforeend", clone);
  parentSelector.insertAdjacentHTML("beforeend", clone);
  parentSelector.insertAdjacentHTML("beforeend", clone);
  parentSelector.insertAdjacentHTML("beforeend", clone);
  parentSelector.insertAdjacentHTML("beforeend", clone);
  parentSelector.insertAdjacentHTML("beforeend", clone);

  setInterval(function () {
    firstElement.style.marginLeft = `-${i}px`;
    if (i > firstElement.clientWidth) {
      i = 0;
    }
    i = i + speed;
  }, 0);
}

//after window is completed load
//1 class selector for marquee
//2 marquee speed 0.2
$(".marquee").each(function( index ) {
  var marquee_attr = $(this).attr("data-marquee");
  window.addEventListener("load", marquee("."+marquee_attr, 0.2));
});


// Personalization
$(document).on("click","#personalize_toggle",function() {
  $(this).addClass("hide");
  $(".personalization_tab").removeClass("hide");
});


$(document).on("click",".swatch-button",function() {
  
   console.log("clicked");
   let selected_value = $('input[name="personalizationprod"]:checked').attr("id");
   $("#"+selected_value).prop('checked', false);
   $("#personalize_btn").attr("disabled","disabled"); 
});

$('input[type=radio][name=personalizationprod]').on('change', function() {
  let prod_val = $('input[name="personalizationprod"]:checked').val();
  let prod_price = $('input[name="personalizationprod"]:checked').attr("data-price");
  let prod_sku = $('input[name="personalizationprod"]:checked').attr("data-sku");

  $("#product-single__variants_options").attr("data-sku",prod_sku);
  $("#product-single__variants_options").attr("value",prod_val);
  $("#product-single__variants_options").attr("data-var-price",prod_price);
  
  if($("[name=add]").attr("disabled") != 'disabled'){
    $("#personalize_btn").removeAttr("disabled");
  }
})

// $('.single-item').slick();

// $(window).load(function() {
//   $(".pageloader").fadeOut("slow");
// });

// $(".overlay").fadeIn();
//         setTimeout(function(){
//           $(".overlay").fadeOut(2000);
//           $(".collslider-section").fadeIn(1000);
//         },500);

//complex collection
$(document).ready(function() {
 // $('.more_item').css('display','none');
  $(document).on('click','.view_all',function(){ 
   $(this).parents('.collection-grid__wrapper').find('.more_item').show();
 //     console.log(selector);
    $(this).css('display','none'); 
  });
});



